import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-anchor-right-up-icon',
  templateUrl: './design-anchor-right-up.component.html'
})
export class DesignAnchorRightUpComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
